import { exportLeaderboard, getTournamentLeaderboardEntries } from 'services/games';
import { useEffect, useState } from 'react';
import MDTypography from 'components/MDTypography';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'components/DashboardNavbar';
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import DataTable from 'components/DataTablePage/components/DataTable';
import entriesColumnData from 'data/entriesColumnData';
import DataTablePage from 'components/DataTablePage';

function LeaderboardEntries() {
  let entriesId = window.location.pathname.split('/').pop();
  const [leaderboard, setLeaderboard] = useState({});

  useEffect(() => {
    getTournamentLeaderboardEntries(entriesId).then((res) => {
      console.log('TOUR', res.data.data);
      setLeaderboard(res.data.data);
    });
  }, []);

  const exportButton = (
    <MDButton
      color='info'
      onClick={async () => {
        const response = await exportLeaderboard(entriesId);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'leaderboard_export.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
      }}
    >
      Export leaderboard
    </MDButton>
  );

  return (
    <>
      <DataTablePage
        title='Leaderboard Entries'
        canSearch
        canFilter
        fetchData={() => getTournamentLeaderboardEntries(entriesId)}
        queryKey='entries'
        columnData={entriesColumnData}
        object={'entry'}
        noActions={true}
        createButton={exportButton}
      />
    </>
  );
}

export default LeaderboardEntries;
